import * as AuthHelper from './APIHelper';

export const GetImage = () => {
    return AuthHelper.getResponse('/image');
}

export const GetImageWithParams = (params) => {
    return AuthHelper.getResponse(`/image?${params}`);
}

export const GetImageUploadUrl = (params) => {
    return AuthHelper.getResponse(`/image/upload-url?${params}`);
}

export const UploadToGCS = async (uploadUrl, file) => {
    const body = await new Response(file).blob();
    const response = await fetch(uploadUrl, {
        method: 'PUT',
        headers: { 'Content-Type': file.type || 'image/jpeg' },
        body,
    });
    if (!response.ok) {
        throw new Error(`GCS upload failed with status ${response.status}`);
    }
    return response;
}

export const PostImage = (payload) => {
    return AuthHelper.postResponse('/image', payload);
}

export const PutImage = (id, payload) => {
    return AuthHelper.putResponse(`/image/${id}`, payload);
}

export const DeleteImage = (id) => {
    return AuthHelper.deleteResponse(`/image/${id}`);
}